import { get } from '.';

export function GetMostRecentlyUsedAndMostUsedDispositionsForAccountUser(options={}) {
    return get<any>("/app/api/disposition_account_users/most_recently_most_used", options);
}